/**
 * An individual slice of navigation pie.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function PieSlice({
  entityId,
  hoveredAspect,
  index,
  matrixTransform,
  setHoveredAspect,
}) {

   /* eslint-disable jsx-a11y/no-static-element-interactions */
  const aspects = [
    'environment',
    'health',
    'relationship',
    'security',
    'purpose',
    'community',
  ];
  const { sectionLink } = drupalSettings.wheel.aspects[entityId].subAspects[0];
  const transformRotate = [
    'rotate(90 330 203)',
    'rotate(30 330 203)',
    'rotate(330 330 203)',
    'rotate(-90 330 203)',
    'rotate(210 330 203)',
    'rotate(150 330 203)',
  ];
  const sliceClasses = {
    'is-hovered': (entityId === hoveredAspect),
    'slice-1': index === 0,
    'slice-2': index === 1,
    'slice-3': index === 2,
    'slice-4': index === 3,
    'slice-5': index === 4,
    'slice-6': index === 5,
  };
  const sliceId = {
    'slice-1': index === 0,
    'slice-2': index === 1,
    'slice-3': index === 2,
    'slice-4': index === 3,
    'slice-5': index === 4,
    'slice-6': index === 5,
  };
  const xyPos = [
    { x: 240, y: 105 },
    { x: 305, y: 110 },
    { x: 330, y: 153 },
    { x: 305, y: 197.5 },
    { x: 250, y: 195 },
    { x: 225, y: 155 },
  ];
  const onMouseEnter = () => setHoveredAspect(entityId);
  const onMouseLeave = () => setHoveredAspect(null);
  sliceClasses[aspects[index]] = true;
  return (
    <a
      tabIndex={-1}
      aria-label={aspects[index]}
      href= {sectionLink}
      className={classnames(sliceClasses)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      transform={matrixTransform}
    >
      <path className="wheel-slice" d="M250,250 l250,0 A250,250 0 0,0 375,33.49364905389035 z" />
      <use
        width="100"
        height="100"
        transform={transformRotate[index]}
        xlinkHref={`#icon-${aspects[index]}`}
        {...xyPos[index]}
      />
    </a>
  );
}

PieSlice.propTypes = {
  entityId: PropTypes.string,
  hoveredAspect: PropTypes.string,
  index: PropTypes.number,
  matrixTransform: PropTypes.string,
  setHoveredAspect: PropTypes.func,
};

export default PieSlice;



// WEBPACK FOOTER //
// js/src/wheel/PieSlice.js